module.exports = __webpack_public_path__ + "static/media/dashboard_top_navbar_icon.10afb604.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard_top_navbar_icon.svg
// module id = 436
// module chunks = 1